module.exports = __webpack_public_path__ + "img/youxi.155bc5a8.png";